<template>

<v-dialog v-if="dialogVisible" min-width="150" max-width="450" v-model="settings.visible" :hide-overlay=false scrollable>
    <div class="dialog-container rounded pa-3"> 
        <div class="heading">Copy Contact to Offices</div>
        <ChipSelector style="max-height:300px;overflow-y:auto;" :items="offices" />
        <div class="text-xs-center">
            <v-btn @click="select" color="primary">{{buttonText}}</v-btn>
        </div>        
    </div>

</v-dialog>

</template>

<script>
import Utilities from '../helpers/Utilities'
import ChipSelector from '../ui-elements/ChipSelector'
import DataHelpers from '../helpers/DataHelpers'
import OrderHelpers from '../helpers/OrderHelpers'
export default {

props:{
    settings: Object,
    //visible, cancelLabel, saveLabel, closeOnly

    saveOnEnter: Boolean,
    disabled: {
        type: Boolean,
        default: false
    }
},

components:{
    ChipSelector,
},

data() {
    return {
        offices: []
    }
},

computed: {

    dialogVisible() {
        return this.settings.visible
    },  
    buttonText() {
        if(this.selectedOffices.length > 1)
            return `Copy to ${this.selectedOffices.length } Offices`
        if(this.selectedOffices.length == 1)
            return 'Copy to 1 Office'
        return 'Cancel'
    },
    selectedOffices() {
        return this.offices.filter(o => o._selected)
    }
    
},

methods: {
    select() {
        this.$emit('select', this.selectedOffices)
        this.settings.visible = false
    },

    loadOffices() {
        this.offices =  this.$store.getters.offices.filter(o => o.meta.key != DataHelpers.getTenantKey()).sort(OrderHelpers.sortByName)
    },

    // save() {
    //     this.$emit('save')
    //     this.settings.visible = false
    // },
    
    // cancel() {
    //     this.$emit('cancel')
    //     this.settings.visible = false
    // },

    // enterPressed() {
    //     if(this.saveOnEnter)
    //         this.save()
    // },

    // focusFirstElement() {
    //     // setTimeout( () => {
    //     //     if(Utilities.isMobile())
    //     //         return
    //     //     let el = this.$refs.dialogDOM.$el.querySelector("input")
    //     //     if(el)
    //     //         el.focus()
    //     // },500)
    // }


},

created() {
    
},

watch: {
    'settings.visible' (visible) {
        if (visible) {
            this.loadOffices()
            this.offices.forEach(office => {
                this.$set(office, '_selected', false)
            })
        } 
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// OfficeSelectionDialog.vue?77fd134e